var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCapricorn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8C6 6.89543 5.10457 6 4 6V4C5.26949 4 6.40086 4.59139 7.13362 5.51371C7.95796 4.58513 9.16065 4 10.5 4C12.9853 4 15 6.01472 15 8.5V10.5351C15.5883 10.1948 16.2714 10 17 10C19.2091 10 21 11.7909 21 14C21 16.2091 19.2091 18 17 18C16.1227 18 15.3113 17.7175 14.6518 17.2386C13.9718 18.8606 12.369 20 10.5 20V18C11.8807 18 13 16.8807 13 15.5V8.5C13 7.11929 11.8807 6 10.5 6C9.11929 6 8 7.11929 8 8.5V14H6V8ZM15 14C15 15.1046 15.8954 16 17 16C18.1046 16 19 15.1046 19 14C19 12.8954 18.1046 12 17 12C15.8954 12 15 12.8954 15 14Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCapricorn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/capricorn.5616ce0909b9375160c618a9c55b5f21.svg";